// @flow
import PlainListMonths, { type ListMonthsProps } from './plain-list-months';

export default PlainListMonths;
export type { ListMonthsProps };
